$(document).ready(function () {
    if ($('.subnav__items li').length) {
        $('.subnav__items li').on('click', function (e) {
            const element = $(e.currentTarget)[0];
            const col = $(element).prevAll('li').length.toString();
            const categoryText = e.currentTarget.innerText;
            const sectionType = window.location.href.indexOf('/movies') !== -1 ? 'Movies' : 'Shows';
            const category = categoryText == 'all' ? 'All ' + sectionType : categoryText;
            let trackParams = {
                menuItemLabel: `${sectionType}-${category}`,
                menuOrientation: 'header',
                posColNum: col,
                posRowNum: '0',
                showBrowseCategory: sectionType == 'Shows' ? category : '',
                movieBrowseCategory: sectionType == 'Movies' ? category : '',
            };

            if (typeof om != 'undefined') {
                om.trackAction('trackSubMenu', trackParams);
            }
            localStorage.setItem('trackSubMenu', JSON.stringify(trackParams));
        });
    }
});
